import React from "react";
import _ from "lodash";
import ChartContainer from "./ChartContainer";

export default function CompetencesChart({ title, data, width, height }) {
  const options = {
    type: "horizontalBar",
    data: {
      labels: _.map(data, "label"),
      datasets: [
        {
          data: _.map(data, "score_percent"),
          backgroundColor: "rgba(132, 206, 230, 1)",
        },
      ],
    },
    options: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: false,
      },
      layout: {
        padding: {
          left: 10,
          top: 0,
          bottom: 0,
          right: 10,
        },
      },
      tooltips: {
        displayColors: false,
      },
      scales: {
        xAxes: [
          {
            ticks: {
              beginAtZero: true,
              max: 100,
              min: 0,
              stepSize: 25,
              autoSkip: true,
              callback: function (value, index, values) {
                return index === values.length - 1 ? value + "%" : value;
              },
            },
          },
        ],
        yAxes: [
          {
            ticks: {
              autoSkip: false,
              callback: function (value, index, values) {
                value = "" + value; // Make sure we deal with a string
                return _.truncate(value, { length: 18 });
              },
            },
            gridLines: { display: false },
          },
        ],
      },
    },
  };
  return (
    <ChartContainer
      id="competence-chart-canvas"
      title={title}
      data={data}
      options={options}
      width={width}
      height={height}
    />
  );
}
